import { CREATE_HOUSE, CREATING_HOUSE, UPDATE_HOUSE, UPDATING_HOUSE, GET_HOUSES, GETTING_HOUSES, HOUSING_ERROR, CREATING_HOUSE_BLOCK, CREATE_HOUSE_BLOCK, GETTING_HOUSE_BLOCKS, GET_HOUSE_BLOCKS, UPDATING_HOUSE_BLOCK, UPDATE_HOUSE_BLOCK } from "../types";

const initialState = {
    houses: [],
    loadingHouses: true,
    housingError: null,
    creatingHouse: false,
    createdHouse: null,
    updatingHouse: false,
    updatedHouse: null,
    blocks: [],
    loadingBlocks: true,
    creatingBlock: false,
    createdBlock: null,
    updatingBlock: false,
    updatedBlock: null,
    creatingRoom: false,  
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case CREATING_HOUSE:
        return {
            ...state,
            creatingHouse :action.payload,
        }
        case CREATE_HOUSE:
        return{
            ...state,
            creatingHouse:false,
            housingError:  null,
            createdHouse: action.payload,
        }
        case UPDATING_HOUSE:
        return {
            ...state,
            updatingHouse :action.payload,
        }
        case UPDATE_HOUSE:
        return{
            ...state,
            updatingHouse:false,
            housingError:  null,
            updatedHouse: action.payload,
        }
        case GETTING_HOUSES:
        return {
            ...state,
            loadingHouses :action.payload,
        }
        case GET_HOUSES:
        return{
            ...state,
            loadingHouses:false,
            housingError:  null,
            houses: action.payload,
        }
        case CREATING_HOUSE_BLOCK:
        return {
            ...state,
            creatingBlock :action.payload,
        }
        case CREATE_HOUSE_BLOCK:
        return{
            ...state,
            creatingBlock:false,
            housingError:  null,
            createdBlock: action.payload,
        }
        case GETTING_HOUSE_BLOCKS:
        return {
            ...state,
            loadingBlocks:action.payload,
        }
        case GET_HOUSE_BLOCKS:
        return{
            ...state,
            loadingBlocks:false,
            housingError:  null,
            blocks: action.payload,
        }
        case UPDATING_HOUSE_BLOCK:
        return {
            ...state,
            updatingBlock :action.payload,
        }
        case UPDATE_HOUSE_BLOCK:
        return{
            ...state,
            updatingBlock:false,
            housingError:  null,
            updatedBlock: action.payload,
        }
        case HOUSING_ERROR:
        return{
            ...state,
            loadingHouses:false,
            creatingHouse: false,
            updatingHouse: false,
            housingError: action.payload 
        }
        default: return state
    }

}